export const bpStepOver = <svg version="1.0" id="Layer_1" x="0px" y="0px"
  viewBox="0 0 512 512" enableBackground="new 0 0 512 512">
  <path d="M425,270c-10.6,0-20.9-5.7-26.4-15.7l-0.9-1.7c-39.8-73.5-85.8-110.1-136.8-108.6c-75.3,2.2-109.1,50.2-144.8,101.1
	c-2.9,4.1-5.8,8.2-8.6,12.3c-9.6,13.5-28.3,16.6-41.8,7c-13.5-9.6-16.6-28.3-7-41.8c2.8-3.9,5.6-7.9,8.4-11.9
	c18.9-26.9,40.3-57.4,69.7-81.6c35.2-29,75.2-43.7,122.5-45c27-0.8,53.3,5.2,78.1,17.7c19.9,10,38.9,24.3,56.5,42.4
	c30.2,31,48.7,65.3,56.7,79.9l0.9,1.6c7.9,14.6,2.5,32.8-12,40.7C434.8,268.8,429.9,270,425,270z"/>
  <path d="M475,275H315c-16.6,0-30-13.4-30-30s13.4-30,30-30h100V115c0-16.6,13.4-30,30-30s30,13.4,30,30V275z" />
  <circle cx="265.2" cy="389.2" r="64.1" />
</svg>
